<template>
<div>
  <h1 class="f1">Players</h1>
  <div class="mt3 mb4" v-if="allPermissions || permissions.canAdd">

    <b-button
      v-if="allPermissions || permissions.canAdd.human"
      @click="addPlayer('human')"
      icon-left="male"
      outlined
      type="is-primary"
      class="mr3">
      <span>Add Human</span>
    </b-button>

    <b-button
      v-if="allPermissions || permissions.canAdd.bot"
      @click="addPlayer('bot')"
      icon-left="robot"
      outlined
      type="is-primary">
      <span>Add Robot</span>
    </b-button>

  </div>
  <transition-group name="list" tag="div">

    <b-field
      class="player"
      has-addons
      v-for="(player, index) in newValue"
      :key="`player-${player.id}`">

      <p class="control">
        <b-button
          v-if="player.type === 'bot'"
          icon-right="robot"
          outlined></b-button>
        <b-button
          v-else
          icon-right="male"
          outlined
          type="is-static"></b-button>
      </p>

      <b-input
        style="flex:1;"
        v-model="player.name"
        :read-only="!allPermissions && !permissions.canChangeNames"
        @keyup.enter.stop="editPlayer = null"></b-input>

      <p class="control" v-if="(allPermissions || permissions.canRemovePlayers)">
        <b-button
          @click="removePlayer(player, index)"
          icon-right="times"
          type="is-danger"
          :disabled="player.id === $store.state.user.id"></b-button>
      </p>
    </b-field>

  </transition-group>
</div>
</template>

<script>
import Bot from '@/classes/Bot';

export default {
  props: {
    permissions: {
      type: [Object, String],
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      newValue: this.value,

      editPlayer: null,
    };
  },

  methods: {
    addPlayer(type, name) {
      const player = type === 'bot' ?
        new Bot(`bot-${this.newValue.length + 1}`) :
        {
          id: Date.now().toString(),
          type,
          name: name || `${type}-${this.newValue.length + 1}`,
          score: 0,
        };

      this.newValue.push(player);
      this.$emit('input', this.newValue);
    },
    removePlayer(player, index) {
      // console.log(index);
      this.$delete(this.newValue, index);
      this.$emit('input', this.newValue);
    },
  },

  computed: {
    allPermissions() {
      return this.permissions === 'all';
    },
  },
};
</script>

<style lang="scss" scoped>
.player {
  // height: ;
  overflow: hidden;
  // position: relative;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // z-index: 10;
  // // padding: 0 20px;
  margin-bottom: 0px;
  height: 55px;
}
</style>
